/* eslint-disable max-len */
import React, { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const SettingsIcon = memo(() => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M5.45 19.35V12.2h-2v-.7h4.7v.7h-2v7.15zm0-10.85V4.65h.7V8.5zm4.2 0v-.7h2V4.65h.7V7.8h2v.7zm2 10.85V11.5h.7v7.85zm6.2 0V16.2h-2v-.7h4.7v.7h-2v3.15zm0-6.85V4.65h.7v7.85z"
      />
    </svg>
  </IconWrapper>
));
